"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBorder = exports.BorderContext = void 0;
const react_1 = require("react");
const initialState = {
    borderType: 'all',
    setBorderType: () => undefined,
    borderWeight: 0,
    setBorderWeight: () => undefined,
    strokeType: 'set_stroke-full',
    setStrokeType: () => undefined,
    borderColor: 'black',
    setBorderColor: () => undefined,
};
exports.BorderContext = (0, react_1.createContext)(initialState);
function useBorder() {
    return (0, react_1.useContext)(exports.BorderContext);
}
exports.useBorder = useBorder;
//# sourceMappingURL=Border.context.js.map